import React from 'react';
import { TrackToggle } from '@livekit/components-react';
import { MediaDeviceMenu } from '@livekit/components-react';
import { Track } from 'livekit-client';
import { useNoiseCancellation } from './NoiseCancellationContext';

export function MicrophoneSettings() {
  const { isEnabled, isPending, isSupported, toggle } = useNoiseCancellation();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* Microphone Toggle and Device Selection */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '6px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <section className="lk-button-group" style={{ display: 'flex', gap: '8px' }}>
          <TrackToggle source={Track.Source.Microphone}>Microphone</TrackToggle>
          <div className="lk-button-group-menu">
            <MediaDeviceMenu kind="audioinput" />
          </div>
        </section>
      </div>

      {/* Enhanced Noise Cancellation */}
      <div
        style={{
          padding: '12px',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '6px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        {!isSupported ? (
          <div
            style={{
              padding: '12px 16px',
              borderRadius: '6px',
              background: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              color: '#ef4444',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Cancelamento de ruído não disponível (WebAssembly não suportado)
          </div>
        ) : (
          <button
            className="lk-button"
            onClick={toggle}
            disabled={isPending}
            aria-pressed={isEnabled}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: '6px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              background: isEnabled ? 'var(--lk-accent-bg)' : 'rgba(255, 255, 255, 0.1)',
              color: isEnabled ? 'var(--lk-accent-fg)' : 'var(--lk-fg)',
              cursor: isPending ? 'not-allowed' : 'pointer',
              opacity: isPending ? 0.6 : 1,
              transition: 'all 0.2s ease',
              fontSize: '14px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            {isPending ? (
              'Processando...'
            ) : (
              <>
                <div
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: isEnabled ? 'currentColor' : 'rgba(255, 255, 255, 0.5)',
                  }}
                />
                {isEnabled
                  ? 'Cancelamento de Ruído Ativado'
                  : 'Ativar Cancelamento de Ruído'}
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
}
